import React, { FC } from 'react';
import { BasketType } from '../../../models/basket-type';
import { USPItemType } from '../../../models/product-card-labels-type';
import UspList from './usp-list';

interface Props {
  readonly basket: BasketType;
  items: USPItemType[];
}

const UspListBasket: FC<Props> = ({ items, basket }) => {
  if (!basket?.lineItems?.length) {
    return null;
  }
  return <UspList items={items} />;
};

export default UspListBasket;
